/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/attributes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getAllAttributes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/dk-game-registry/dk-registry-entries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getDkGameRegistryEntries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/dk-game-registry/fetch-and-validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["fetchAndValidateDkGameRegistry"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/dk-game-registry/game-configuration-entries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getDkGameRegistryGameConfigurationEntries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/dk-game-registry/populate-game-registry-names": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["populateGameRegistryNames"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/dk-game-registry/populate-game-registry-references": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["populateGameRegistryReferences"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/dk-game-registry/validation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["validateDkGameRegistry"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/export/active-game-configurations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["exportActiveGameConfigurations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/export/import-format": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["exportGamesForImportFormat"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/export/ukgc-format": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["exportGamesForUkgcFormat"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-codes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getAllGameCodes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configuration/{gameSlug}/opening-hours": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getGameConfigurationOpeningHours"];
        put: operations["setGameConfigurationOpeningHours"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getGameConfigurations"];
        put?: never;
        post: operations["createGameConfiguration"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations/{gameSlug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getGameConfigurationBySlug"];
        put: operations["updateGameConfiguration"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations/{gameSlug}/attributes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getGameConfigurationAttributes"];
        put?: never;
        post: operations["setGameConfigurationAttribute"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations/{gameSlug}/cachebust": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["cachebustGameConfigurations"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations/{gameSlug}/game-codes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getGameCodes"];
        put?: never;
        post: operations["addGameCodes"];
        delete: operations["deleteGameCodes"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations/{gameSlug}/random-number-generator": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** @description Update the random number generator id and/or software id on a game configuration. Fields omitted or sent as null are left unchanged. */
        patch: operations["updateGameConfigurationRandomNumberGenerator"];
        trace?: never;
    };
    "/api/game-configurations/game-codes/{gameCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getGameConfigurationByGameCode"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations/sort-indexes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Receives an ordered array of gameSlugs to set sort order of games. GameSlugs not present in the input, will be put to the bottom. */
        post: operations["setGameConfigurationSortIndexes"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-configurations/update-hero-colours": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Extracts the dominant colour from the game tile image for all game configurations and saves it. */
        post: operations["updateAllGameHeroColours"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/game-search/game-configurations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Lightweight endpoint returning only the fields needed by game-search. */
        get: operations["getGameConfigurationsForGameSearch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/lists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Returns all sorting lists */
        get: operations["getSortingLists"];
        put?: never;
        post: operations["insert into ai list"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/providers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getProviders"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/providers/{providerSlug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getProvider"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Returns all sorting lists with full backoffice fields (active, personal, sorting_method, brand). */
        get: operations["getSortingListsForBackoffice"];
        put?: never;
        /** @description Creates a new sorting list. */
        post: operations["createSortingList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Returns a single sorting list by slug and brand. */
        get: operations["getSortingList"];
        /** @description Updates a sorting list's metadata. */
        put: operations["updateSortingList"];
        post?: never;
        /** @description Deletes a sorting list and its game entries. */
        delete: operations["deleteSortingList"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}/copy": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Copies a sorting list (and its games/page slugs) to a target brand. */
        post: operations["copySortingList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}/games": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Returns all games in a sorting list with their sort indexes and lock state. */
        get: operations["getSortingListGames"];
        put?: never;
        /** @description Bulk adds games to a sorting list by game slug. */
        post: operations["addGamesToSortingList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}/games/{gameSlug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** @description Removes a game from a sorting list. */
        delete: operations["removeGameFromSortingList"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}/games/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Searches for games not yet in the sorting list, matching the given name. */
        get: operations["searchGamesForSortingList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}/import-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Adds all active games for the brand into the sorting list (skipping duplicates). */
        post: operations["importAllGamesIntoSortingList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}/sort": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Applies the list's configured sorting method to re-sort its games. */
        post: operations["sortSortingListByCriteria"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/{slug}/sort-indexes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Saves the game ordering (sort indexes and lock state) within a sorting list. */
        post: operations["saveSortIndexesForSortingList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/copy-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Copies all sorting lists from one brand to another, skipping those that already exist. */
        post: operations["copyAllSortingLists"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sorting-lists/positions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Saves the position ordering of sorting lists for a brand. */
        post: operations["saveSortingListPositions"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/uk-game-register/suggested-references": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns the same suggested game register references that are shown on the
         *     game configuration edit page for a given game name.
         */
        get: operations["getSuggestedUkGameRegisterReferences"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/ukgc/validation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["ValidateUkgcCsv"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/vendor-game-register/{vendor}/import": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["importVendorGameRegister"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/vendors": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getVendors"];
        put?: never;
        post: operations["createVendor"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backoffice/game-configurations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The backoffice picker contract: slug, name, provider, every configured brand (brands) and the subset the game is active on (active_brands). Independent of game-search. */
        get: operations["getGameConfigurationsForBackoffice"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/game-configurations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Paginateable endpoint for use by the public site. Only returns games where the game, vendor AND provider has is_active set to true. Default ordering is by sort_index ascending as primary and created_at descending as secondary. */
        get: operations["getPublicGameConfigurations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/game-configurations/{gameSlug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getPublicGameConfiguration"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/game-configurations/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Endpoint for getting game data from custom sorting lists using slugs. Games are returned ordered by sort_index. Supports pagination via page/page_size; when page_size is omitted all games are returned (legacy behavior). */
        get: operations["searchPublicGameConfigurationsGameSorting"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/game-configurations/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Endpoint for getting game data by different filters and inputs. Endpoint is POST due to GET not necessarily supporting request body ([see RFC9110](https://www.rfc-editor.org/rfc/rfc9110#section-9.3.1-6)) */
        post: operations["searchPublicGameConfigurations"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/game-configurations/slugs/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Simple endpoint for getting active game slugs, ordered by sort-index. */
        get: operations["getPublicGameConfigurationSlugs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/game-configurations/vendor-provider-search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Endpoint for getting game data by filtering on vendors and providers only. All search in this endpoint is inclusive */
        post: operations["vendorProviderSearchPublicGameConfigurations"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/jackpots": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getPublicJackpots"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/jackpots/combined": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["getPublicCombinedJackpot"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/lists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Returns all active sorting lists for a brand */
        get: operations["getActiveListsForBrand"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/vendors": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Returns all active vendors */
        get: operations["getPublicVendors"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        AiListItemData: {
            rank?: number;
            slug?: string;
            user_id?: number;
        };
        AiListRequest: {
            items?: components["schemas"]["AiListItemData"][];
            listSlug?: string;
        };
        AllGameAttributesRepresentation: {
            attributes?: components["schemas"]["AttributesRepresentation"];
            slug?: string;
        };
        AttributesRepresentation: {
            ACTIVE_CAMPAIGN_AMOUNT?: (string | Record<string, never>) | null;
            IS_ENGAGE_ENABLED?: (string | Record<string, never>) | null;
            LAUNCH_TERMS?: (string | Record<string, never>) | null;
            LIVESTREAM_ACCOUNT?: (string | Record<string, never>) | null;
            LIVESTREAM_ID?: (string | Record<string, never>) | null;
        };
        CreateGameCodesRequest: {
            game_codes?: [
                string,
                ...string[]
            ];
        };
        CreateGameConfigurationAttributeRequest: {
            key?: string;
            value?: string;
        };
        CreateGameConfigurationRequest: {
            desktop_game_codes?: string[] | null;
            exclude_from_bonus_funds?: boolean;
            excluded_from_bonus_funds?: {
                [key: string]: boolean;
            };
            exclusive_until?: {
                [key: string]: unknown | Record<string, never>;
            };
            game_codes?: [
                string,
                ...string[]
            ];
            game_registry_name?: string | null;
            game_registry_reference_primary?: string | null;
            game_registry_reference_secondary?: string | null;
            game_registry_version?: string | null;
            game_subtype?: components["schemas"]["GameSubtype"] | null;
            game_type?: components["schemas"]["GameType"];
            has_jackpot?: boolean;
            is_active?: {
                [key: string]: boolean;
            };
            is_exclusive?: {
                [key: string]: boolean;
            };
            is_new?: {
                [key: string]: boolean;
            };
            is_recommended?: {
                [key: string]: boolean;
            };
            is_staff_only?: {
                [key: string]: boolean;
            };
            jackpot_pretty_name?: string | null;
            name?: string;
            provider_slug?: string;
            random_number_generator_id?: string | null;
            random_number_generator_software_id?: string | null;
            rtp?: string;
            safe_game_category?: components["schemas"]["SafeGameCategory"] | null;
            slug?: string;
            tile_type?: {
                [key: string]: components["schemas"]["TileType"];
            };
            ukgc_game_category?: components["schemas"]["UkgcGameCategory"] | null;
            vendor_slug?: string;
        };
        CreateProviderRequest: {
            is_active?: boolean;
            name?: string;
            slug?: string;
        };
        CreateVendorRequest: {
            exclude_from_bonus_funds?: boolean;
            external_id?: string;
            is_active?: boolean;
            name?: string;
            provider_slug?: string;
            slug?: string;
        };
        DeleteGameCodesRequest: {
            game_codes?: [
                string,
                ...string[]
            ];
        };
        DkGameRegistryEntryRepresentation: {
            /** @example 2025-03-26T12:01:16.000Z */
            Created?: unknown;
            /** @example true */
            Deleteable?: boolean | null;
            /** @example Slot machine */
            Game_Category?: string | null;
            Game_Developer?: string | null;
            /** @example 95.5 */
            Game_RTP?: string | null;
            /** @example Tester */
            Name?: string;
            /** @example XYC-60027-1060 */
            Register_Reference?: string | null;
            /** @example Active */
            Status?: string | null;
            /** @example MagnetGamingTest */
            Supplier_Name?: string | null;
            /** @example 2025-01-23 */
            Test_Report_Date?: string | null;
            /** @example 125-22500.01-SCP.01 */
            Test_Report_Reference?: string | null;
            /** @example 313E982BC1A07997E0632C0318AC4101 */
            Uuid?: string | null;
            /** @example 9.9.9 */
            Version?: string | null;
        };
        DkGameRegistryValidationRequest: {
            entries?: components["schemas"]["DkGameRegistryEntryRepresentation"][];
        };
        GameCodeDetailRepresentation: {
            /** @description Whether this code is the desktop variant. False means mobile (the default). */
            desktop?: boolean;
            game_code?: string;
        };
        GameCodeRepresentation: {
            game_code?: string;
        };
        GameCodesRepresentation: {
            gameCodes?: components["schemas"]["GameCodeRepresentation"][];
            slug?: string;
        };
        GameConfigurationAttributesRepresentation: {
            attributes?: components["schemas"]["AttributesRepresentation"];
            slug?: string;
        };
        GameConfigurationJackpotsRepresentation: {
            jackpots?: components["schemas"]["JackpotRepresentation"][];
            slug?: string;
        };
        GameConfigurationRepresentation: {
            /** @description Map of asset name to whether the asset URL is reachable. Null when not yet checked. */
            asset_availability?: {
                [key: string]: boolean;
            } | null;
            /** @example #3a7bc5 */
            game_hero_colour?: string | null;
            game_registry_name?: string | null;
            /** @description Temporarily not required as all games does not yet have a reference set */
            game_registry_reference_primary?: string | null;
            game_registry_reference_secondary?: string | null;
            /** @description Temporarily not required as all games does not yet have a version set */
            game_registry_version?: string | null;
            game_subtype?: components["schemas"]["GameSubtype"] | null;
            game_type?: components["schemas"]["GameType"];
            has_jackpot?: boolean;
            /**
             * @deprecated
             * @description DEPRECATED: Use multibrand_game_properties instead
             */
            is_active?: boolean;
            /**
             * @deprecated
             * @description DEPRECATED: Use multibrand_game_properties instead
             */
            is_new?: boolean;
            /**
             * @deprecated
             * @description DEPRECATED: Use multibrand_game_properties instead
             */
            is_recommended?: boolean;
            /**
             * @deprecated
             * @description DEPRECATED: Use multibrand_game_properties instead
             */
            is_staff_only?: boolean;
            jackpot_pretty_name?: string | null;
            multibrand_game_properties?: {
                [key: string]: components["schemas"]["MultibrandGamePropertiesRepresentation"];
            };
            name?: string;
            /** @example magnet */
            provider_slug?: string;
            /** @example random-number-generator */
            random_number_generator_id?: string | null;
            /** @example 1.0.0 */
            random_number_generator_software_id?: string | null;
            /** @example 96.4 */
            rtp?: string | null;
            safe_game_category?: components["schemas"]["SafeGameCategory"] | null;
            slug?: string;
            /**
             * @deprecated
             * @description DEPRECATED: Use multibrand_game_properties instead
             */
            sort_index?: number;
            tile_type?: components["schemas"]["TileType"];
            ukgc_game_category?: components["schemas"]["UkgcGameCategory"] | null;
            updated_at?: unknown;
            /** @example magnet */
            vendor_slug?: string;
        };
        /** @enum {string} */
        GameSubtype: GameSubtype;
        /** @enum {string} */
        GameType: GameType;
        GetGameConfigurationsRequest: {
            provider_slug?: string | null;
            vendor_slug?: string | null;
        };
        JackpotRepresentation: {
            jackpotPrettyName?: string | null;
            slug?: string;
            type?: components["schemas"]["JackpotType"];
            value?: string;
        };
        /** @enum {string} */
        JackpotType: JackpotType;
        MultibrandGamePropertiesRepresentation: {
            excluded_from_bonus_funds?: boolean;
            exclusive_until?: string | null;
            is_active?: boolean;
            is_exclusive?: boolean;
            is_new?: boolean;
            is_recommended?: boolean;
            is_staff_only?: boolean;
            sort_index?: number;
            tile_decoration?: string | null;
            tile_type?: components["schemas"]["TileType"];
        };
        OnlineStatusRequest: {
            brand?: string;
            slugs?: string[];
        };
        OpeningHourRangeInput: {
            /** @example 08:00 */
            from_time_local?: string;
            /** @example 16:00 */
            to_time_local?: string;
            weekday?: string;
        };
        OpeningHourRepresentation: {
            /** @example 16:00 */
            from_time_local?: string;
            /** @example 22:00 */
            to_time_local?: string;
            weekday?: components["schemas"]["Weekday"];
        };
        OpeningHoursRepresentation: {
            is_open?: boolean;
            /** Format: date-time */
            opens_at?: string | null;
        };
        PaginatedDocumentation: {
            links?: {
                active?: boolean;
                label?: string;
                url?: string | null;
            }[] | null;
            meta?: {
                current_page?: number;
                first_page_url?: string;
                from?: number | null;
                last_page?: number;
                last_page_url?: string;
                next_page_url?: string | null;
                path?: string;
                per_page?: number;
                prev_page_url?: string | null;
                to?: number | null;
                total?: number;
            } | null;
        };
        PaginatedPublicGameConfigurationDocumentation: components["schemas"]["PaginatedDocumentation"] & {
            data?: components["schemas"]["PublicGameConfigurationRepresentation"][];
        };
        ProviderRepresentation: {
            is_active?: boolean;
            name?: string;
            random_number_generator_id?: string | null;
            random_number_generator_software_id?: string | null;
            slug?: string;
            vendors?: components["schemas"]["VendorRepresentation"][];
        };
        PublicGameConfigurationRepresentation: {
            /** @description Map of asset name to whether the asset URL is reachable. Null when not yet checked. */
            asset_availability?: {
                [key: string]: boolean;
            } | null;
            /** @description Map of asset name to the game_tiles folder it is served from. Null when the brand has no asset folder of its own. */
            asset_folders?: {
                [key: string]: string;
            } | null;
            attributes?: components["schemas"]["AttributesRepresentation"];
            created_at?: unknown;
            excluded_from_bonus_funds?: boolean;
            /** @example #3a7bc5 */
            game_hero_colour?: string | null;
            game_subtype?: components["schemas"]["GameSubtype"] | null;
            game_type?: components["schemas"]["GameType"];
            gameCodeDetails?: components["schemas"]["GameCodeDetailRepresentation"][];
            gameCodes?: string[];
            has_jackpot?: boolean;
            is_active?: boolean;
            is_exclusive?: boolean;
            is_new?: boolean;
            is_recommended?: boolean;
            is_staff_only?: boolean;
            name?: string;
            opening_hours?: components["schemas"]["OpeningHoursRepresentation"];
            provider_slug?: string;
            slug?: string;
            sort_index?: number;
            tile_decoration?: string | null;
            tile_type?: components["schemas"]["TileType"];
            updated_at?: unknown;
            vendor_slug?: string;
        };
        PublicSortingListRepresentation: {
            contains_all_games?: boolean;
            horizontal_desktop_lines?: number | null;
            horizontal_lines?: number | null;
            name?: string;
            position?: number | null;
            slug?: string;
            sorting_criteria_description?: string | null;
            tile_display_count?: number | null;
            type?: string;
            video_enabled?: boolean;
        };
        /** @enum {string} */
        SafeGameCategory: SafeGameCategory;
        SearchGameConfigurationsFilterInput: {
            exclude_hidden_tile_types?: boolean | null;
            exclude_new_games?: boolean | null;
            excluded_from_bonus_funds?: boolean | null;
            game_codes?: string[] | null;
            game_types?: components["schemas"]["GameType"][] | null;
            has_jackpot?: boolean | null;
            providers?: string[] | null;
            /** @description Seo name can be either the game slug OR the seo name that matches the game name. A seo name for eg. "Golden Pyramid" would be "golden_pyramid" */
            seo_name?: string | null;
            slugs?: string[] | null;
            vendors?: string[] | null;
        };
        SearchGameConfigurationsListRequest: {
            /** @enum {string} */
            brand?: SearchGameConfigurationsListRequestBrand;
        };
        SearchGameConfigurationsRequest: {
            /** @enum {string} */
            brand?: SearchGameConfigurationsRequestBrand;
            filter?: components["schemas"]["SearchGameConfigurationsFilterInput"] | null;
            /**
             * @description Defaults to SORT_INDEX_ASC
             * @enum {string|null}
             */
            sort?: SearchGameConfigurationsRequestSort;
        };
        SetGameConfigurationOpeningHoursRequest: {
            opening_hour_ranges?: components["schemas"]["OpeningHourRangeInput"][];
        };
        SortGamesForBrandRequest: {
            /** @enum {string|null} */
            brand?: SortGamesForBrandRequestBrand;
            game_slugs?: [
                string,
                ...string[]
            ];
            locked_slugs?: [
                string,
                ...string[]
            ];
        };
        SortingListRepresentation: {
            contains_all_games?: boolean;
            horizontal_desktop_lines?: number | null;
            horizontal_lines?: number | null;
            name?: string | null;
            page_slugs?: string[];
            position?: number | null;
            slug?: string;
            sorting_criteria_description?: string | null;
            tile_display_count?: number | null;
            type?: string | null;
            video_enabled?: boolean;
        };
        /** @enum {string} */
        TileType: TileType;
        UkGameRegisterRepresentation: {
            /** @example bookofdead */
            game_name?: string | null;
            /** @example R.000.001 */
            game_register_reference?: string;
            /** @example Book of Dead */
            pretty_name?: string | null;
            /** @example ["96.21"] */
            rtp?: string;
            /** @example play_and_go */
            vendor?: string | null;
            /** @example 1.0.0 */
            version?: string;
        };
        /** @enum {string} */
        UkgcGameCategory: UkgcGameCategory;
        UpdateGameConfigurationRequest: {
            exclude_from_bonus_funds?: boolean | null;
            excluded_from_bonus_funds?: {
                [key: string]: boolean;
            } | null;
            exclusive_until?: {
                [key: string]: unknown | Record<string, never>;
            } | null;
            game_registry_name?: string | null;
            /** @description Temporarily not required as all games does not yet have a reference set */
            game_registry_reference_primary?: string | null;
            /** @description Relevant if game is being split tested */
            game_registry_reference_primary_split?: string | null;
            game_registry_reference_secondary?: string | null;
            /** @description Relevant if game is being split tested */
            game_registry_reference_secondary_split?: string | null;
            /** @description Temporarily not required as all games does not yet have a version set */
            game_registry_version?: string | null;
            /** @description Relevant if game is being split tested */
            game_registry_version_split?: string | null;
            game_subtype?: components["schemas"]["GameSubtype"] | null;
            game_type?: components["schemas"]["GameType"] | null;
            has_jackpot?: boolean | null;
            is_active?: {
                [key: string]: boolean;
            } | null;
            is_exclusive?: {
                [key: string]: boolean;
            } | null;
            is_new?: {
                [key: string]: boolean;
            } | null;
            is_recommended?: {
                [key: string]: boolean;
            } | null;
            is_staff_only?: {
                [key: string]: boolean;
            } | null;
            jackpot_pretty_name?: string | null;
            name?: string | null;
            provider_slug?: string | null;
            random_number_generator_id?: string | null;
            random_number_generator_software_id?: string | null;
            /** @description Temporarily not required as all games does not yet have an rtp set */
            rtp?: string | null;
            /** @description Relevant if game is being split tested */
            rtp_split?: string | null;
            safe_game_category?: components["schemas"]["SafeGameCategory"] | null;
            tile_decoration?: {
                [key: string]: string | null;
            } | null;
            tile_decoration_expires?: {
                [key: string]: unknown | Record<string, never>;
            } | null;
            tile_type?: {
                [key: string]: components["schemas"]["TileType"];
            } | null;
            ukgc_game_category?: components["schemas"]["UkgcGameCategory"] | null;
            vendor_slug?: string | null;
        };
        UpdateGameRegistryRequest: {
            game_registry_reference_primary?: string | null;
            game_registry_reference_secondary?: string | null;
            game_registry_version?: string | null;
            rtp?: string | null;
            split?: number | null;
        };
        UpdateProviderRequest: {
            is_active?: boolean;
            name?: string;
            random_number_generator_id?: string | null;
            random_number_generator_software_id?: string | null;
        };
        UpdateRandomNumberGeneratorRequest: {
            random_number_generator_id?: string | null;
            random_number_generator_software_id?: string | null;
        };
        UpdateVendorRequest: {
            exclude_from_bonus_funds?: boolean;
            external_id?: string;
            is_active?: boolean;
            name?: string;
            random_number_generator_id?: string | null;
            random_number_generator_software_id?: string | null;
        };
        VendorProviderSearchGameConfigurationsFilterInput: {
            exclude_hidden_tile_types?: boolean | null;
            providers?: string[] | null;
            vendors?: string[] | null;
        };
        VendorProviderSearchGameConfigurationsRequest: {
            /** @enum {string} */
            brand?: VendorProviderSearchGameConfigurationsRequestBrand;
            exclude_hidden_tile_types?: boolean | null;
            page_size?: number | null;
            providers?: string[] | null;
            vendors?: string[] | null;
        };
        VendorRepresentation: {
            exclude_from_bonus_funds?: boolean;
            is_active?: boolean;
            name?: string;
            provider_slug?: string;
            random_number_generator_id?: string | null;
            random_number_generator_software_id?: string | null;
            slug?: string;
        };
        /** @enum {string} */
        Weekday: Weekday;
    };
    responses: never;
    parameters: {
        brandHeaderParameter: ComponentsParametersBrandHeaderParameter;
        brandQueryParameter: ComponentsParametersBrandQueryParameter;
    };
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    getAllAttributes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get All Game Attributes */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AllGameAttributesRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description GameConfiguration was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getDkGameRegistryEntries: {
        parameters: {
            query?: {
                /** @description When true (default), only entries with Status=Active are returned. */
                only_active?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Entries fetched from DK Game Registry API */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    fetchAndValidateDkGameRegistry: {
        parameters: {
            query?: {
                /** @description Send Slack notification with validation result */
                notify_slack?: boolean;
                /** @description When true (default), only entries with Status=Active are compared. */
                only_active?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description DK Game Registry validation passed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description DK Game Registry validation ran with errors */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getDkGameRegistryGameConfigurationEntries: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description All game configurations as DK game register entries */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DkGameRegistryEntryRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    populateGameRegistryNames: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["DkGameRegistryValidationRequest"];
            };
        };
        responses: {
            /** @description game_registry_name populated on matched game configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    populateGameRegistryReferences: {
        parameters: {
            query?: {
                /** @description When true, allow replacing an existing non-null primary reference. Defaults to false (only writes when primary is null). */
                overwrite_reference?: boolean;
                /** @description When true, allow replacing an existing non-null rtp. Defaults to false (only writes when rtp is null). */
                overwrite_rtp?: boolean;
                /** @description When true, allow replacing an existing non-null version. Defaults to false (only writes when version is null). */
                overwrite_version?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["DkGameRegistryValidationRequest"];
            };
        };
        responses: {
            /** @description Game registry references, versions, and RTPs populated */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    validateDkGameRegistry: {
        parameters: {
            query?: {
                /** @description Send Slack notification with validation result */
                notify_slack?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["DkGameRegistryValidationRequest"];
            };
        };
        responses: {
            /** @description DK Game Registry entries processed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    exportActiveGameConfigurations: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get a CSV file with active game configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/csv": string;
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    exportGamesForImportFormat: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get a CSV file with games formatted for CSV import */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/csv": string;
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    exportGamesForUkgcFormat: {
        parameters: {
            query?: {
                brand?: PathsApiExportUkgcFormatGetParametersQueryBrand;
                game_configurations?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get a CSV file with games formatted for UKGC Game Register */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/csv": string;
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getAllGameCodes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Game Codes */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameCodeRepresentation"][];
                };
            };
            /** @description Input is missing or malformed */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description No game codes found with game_configuration_slug */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameConfigurationOpeningHours: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Game Configuration Opening Hours */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OpeningHourRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description GameConfiguration was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Inputted data could not be processed */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    setGameConfigurationOpeningHours: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SetGameConfigurationOpeningHoursRequest"];
            };
        };
        responses: {
            /** @description Set Game Configuration Opening Hours */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description GameConfiguration was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Inputted data could not be processed */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameConfigurations: {
        parameters: {
            query?: {
                brand?: string;
                game_code?: string;
                "is-staff"?: boolean;
                provider_slug?: string;
                vendor_slug?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Game Configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameConfigurationRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createGameConfiguration: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateGameConfigurationRequest"];
            };
        };
        responses: {
            /** @description Created Game Configuration */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameConfigurationRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Vendor slug was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description GameConfiguration with slug already exists */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameConfigurationBySlug: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get game configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameConfigurationRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Game not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateGameConfiguration: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateGameConfigurationRequest"];
            };
        };
        responses: {
            /** @description Updated Game Configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameConfigurationRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Game configuration slug or vendor slug was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameConfigurationAttributes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Game Attributes */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AttributesRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description GameConfiguration was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    setGameConfigurationAttribute: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateGameConfigurationAttributeRequest"];
            };
        };
        responses: {
            /** @description Set a Game Configuration attribute */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description GameConfiguration was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    cachebustGameConfigurations: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Busted assets for game configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Game configuration slug was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameCodes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Game Codes */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameCodeRepresentation"][];
                };
            };
            /** @description Input is missing or malformed */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description No game codes found with game_configuration_slug */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    addGameCodes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateGameCodesRequest"];
            };
        };
        responses: {
            /** @description Created Game Codes */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameCodeRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    deleteGameCodes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["DeleteGameCodesRequest"];
            };
        };
        responses: {
            /** @description Deleted Game Codes */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameCodeRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Game Configuration slug not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateGameConfigurationRandomNumberGenerator: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateRandomNumberGeneratorRequest"];
            };
        };
        responses: {
            /** @description Updated Game Configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameConfigurationRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Game configuration slug was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameConfigurationByGameCode: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                gameCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get game configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameConfigurationRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Game not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    setGameConfigurationSortIndexes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SortGamesForBrandRequest"][];
            };
        };
        responses: {
            /** @description Sort indexes set */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Game configuration slug was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateAllGameHeroColours: {
        parameters: {
            query?: {
                /** @description Only update game configurations that do not already have a hero colour set */
                only_missing?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Hero colours updated for all game configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameConfigurationsForGameSearch: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Game configurations for game-search */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSortingLists: {
        parameters: {
            query?: {
                brand?: string;
                page_slug?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description All sorting lists */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SortingListRepresentation"][];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "insert into ai list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description List saved */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Input is missing or malformed */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getProviders: {
        parameters: {
            query?: {
                is_active?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Providers */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProviderRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getProvider: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                providerSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get provider by slug */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProviderRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSortingListsForBackoffice: {
        parameters: {
            query?: {
                brand?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description List of sorting lists */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createSortingList: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    active?: boolean;
                    brand?: string;
                    name?: string;
                    page_slugs?: string[];
                    slug?: string;
                    type?: string;
                };
            };
        };
        responses: {
            /** @description Created sorting list */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Slug + brand combination already exists */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSortingList: {
        parameters: {
            query: {
                brand: string;
            };
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Sorting list */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateSortingList: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Updated sorting list */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    deleteSortingList: {
        parameters: {
            query: {
                brand: string;
            };
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Deleted */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    copySortingList: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    brand?: string;
                    target_brand?: string;
                };
            };
        };
        responses: {
            /** @description List copied */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Invalid brand parameters */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Source list not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description List already exists in target brand */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSortingListGames: {
        parameters: {
            query: {
                brand: string;
            };
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Games in sorting list */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Sorting list not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    addGamesToSortingList: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    brand?: string;
                    game_slugs?: string[];
                };
            };
        };
        responses: {
            /** @description Games added */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description No games provided */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Sorting list not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description All games already in list */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    removeGameFromSortingList: {
        parameters: {
            query: {
                brand: string;
            };
            header?: never;
            path: {
                gameSlug: string;
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Game removed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    searchGamesForSortingList: {
        parameters: {
            query: {
                brand: string;
                name?: string;
            };
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Matching games not yet in the list */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Sorting list not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    importAllGamesIntoSortingList: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    brand?: string;
                };
            };
        };
        responses: {
            /** @description Games imported */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    sortSortingListByCriteria: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    brand?: string;
                };
            };
        };
        responses: {
            /** @description Sorted */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    saveSortIndexesForSortingList: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                slug: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    brand?: string;
                    games?: {
                        locked?: boolean;
                        slug?: string;
                        sort_index?: number;
                    }[];
                };
            };
        };
        responses: {
            /** @description Sort indexes saved */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Sorting list not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    copyAllSortingLists: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    brand?: string;
                    target_brand?: string;
                };
            };
        };
        responses: {
            /** @description Copy result with copied and skipped counts */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Missing or invalid brand parameters */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    saveSortingListPositions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    brand?: string;
                    positions?: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description Positions saved */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSuggestedUkGameRegisterReferences: {
        parameters: {
            query: {
                game_name: string;
                /** @description Fallback: match any vendor of this provider when the vendor gives no matches */
                provider_slug?: string;
                /** @description Restrict matches to this vendor */
                vendor_slug?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Suggested UK game register references */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UkGameRegisterRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ValidateUkgcCsv: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Upload CSV file */
        requestBody: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description Must be a CSV file
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description Validate ukgc csv */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example Success */
                        status?: string;
                    };
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    importVendorGameRegister: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Vendor slug the register entries belong to, e.g. games-global */
                vendor: string;
            };
            cookie?: never;
        };
        /** @description Upload the vendor's games register CSV */
        requestBody: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description Must be a CSV file
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description Game register imported */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description No file, or the file is not a valid CSV */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unknown vendor */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The CSV was read but rejected — missing headers or required values */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getVendors: {
        parameters: {
            query?: {
                is_active?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Vendors */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VendorRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createVendor: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateVendorRequest"];
            };
        };
        responses: {
            /** @description Created Vendor */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VendorRepresentation"];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Provider slug was not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Vendor with slug already exists for provider */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGameConfigurationsForBackoffice: {
        parameters: {
            query?: {
                /** @description Maximum number of results. Defaults to 50 */
                limit?: number;
                /** @description Case-insensitive substring match on name or slug */
                searchString?: string;
                /** @description Only these games, by slug */
                "slugs[]"?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Game configurations for the backoffice picker */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Missing the game-list-read or game-configurations-read role */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPublicGameConfigurations: {
        parameters: {
            query?: {
                brand?: components["parameters"]["brandQueryParameter"];
                game_type?: components["schemas"]["GameType"];
                is_staff?: boolean;
                page?: number;
                /** @description If not set, page size defaults to all elements. */
                page_size?: number;
            };
            header?: {
                "x-brand"?: components["parameters"]["brandHeaderParameter"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Game Configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaginatedPublicGameConfigurationDocumentation"];
                };
            };
        };
    };
    getPublicGameConfiguration: {
        parameters: {
            query?: {
                brand?: components["parameters"]["brandQueryParameter"];
                is_staff?: boolean;
            };
            header?: {
                "x-brand"?: components["parameters"]["brandHeaderParameter"];
            };
            path: {
                gameSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Game Configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PublicGameConfigurationRepresentation"];
                };
            };
        };
    };
    searchPublicGameConfigurationsGameSorting: {
        parameters: {
            query?: {
                brand?: components["parameters"]["brandQueryParameter"];
                is_staff?: boolean;
                page?: number;
                /** @description If not set, all games are returned (legacy behavior). */
                page_size?: number;
                slug?: string;
            };
            header?: {
                "x-brand"?: components["parameters"]["brandHeaderParameter"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Search Game Configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        games?: components["schemas"]["PublicGameConfigurationRepresentation"][];
                        horizontal_lines?: number;
                        /** @description Pagination metadata. Only present when page_size is set. */
                        meta?: {
                            current_page?: number;
                            from?: number | null;
                            last_page?: number;
                            per_page?: number;
                            to?: number | null;
                            total?: number;
                        };
                        name?: string;
                        type?: string;
                    };
                };
            };
        };
    };
    searchPublicGameConfigurations: {
        parameters: {
            query?: {
                brand?: components["parameters"]["brandQueryParameter"];
                is_staff?: boolean;
                page?: number;
                /** @description If not set, page size defaults to all elements. */
                page_size?: number;
                /** @description Sort options. */
                sort?: PathsPublicGameConfigurationsSearchPostParametersQuerySort;
            };
            header?: {
                "x-brand"?: components["parameters"]["brandHeaderParameter"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SearchGameConfigurationsRequest"];
            };
        };
        responses: {
            /** @description Search Game Configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaginatedPublicGameConfigurationDocumentation"];
                };
            };
        };
    };
    getPublicGameConfigurationSlugs: {
        parameters: {
            query?: {
                brand?: components["parameters"]["brandQueryParameter"];
                is_staff?: boolean;
            };
            header?: {
                "x-brand"?: components["parameters"]["brandHeaderParameter"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Public Game Configuration Slugs */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
        };
    };
    vendorProviderSearchPublicGameConfigurations: {
        parameters: {
            query?: {
                brand?: components["parameters"]["brandQueryParameter"];
                is_staff?: boolean;
                page?: number;
                /** @description If not set, page size defaults to all elements. */
                page_size?: number;
            };
            header?: {
                "x-brand"?: components["parameters"]["brandHeaderParameter"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["VendorProviderSearchGameConfigurationsRequest"];
            };
        };
        responses: {
            /** @description Search Game Configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaginatedPublicGameConfigurationDocumentation"];
                };
            };
        };
    };
    getPublicJackpots: {
        parameters: {
            query?: {
                is_staff?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Jackpots of all game configurations */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GameConfigurationJackpotsRepresentation"][];
                };
            };
        };
    };
    getPublicCombinedJackpot: {
        parameters: {
            query?: {
                is_staff?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Sum of the highest jackpot of each game configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example 123456.78 */
                        amount?: number;
                    };
                };
            };
        };
    };
    getActiveListsForBrand: {
        parameters: {
            query?: {
                brand?: components["parameters"]["brandQueryParameter"];
                /** @description Filter lists by page slug */
                page_slug?: string;
            };
            header?: {
                "x-brand"?: components["parameters"]["brandHeaderParameter"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Active sorting lists for brand */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PublicSortingListRepresentation"][];
                };
            };
            /** @description Unauthorized. Redirects to SSO */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPublicVendors: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get Vendors */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VendorRepresentation"][];
                };
            };
        };
    };
}
export enum PathsApiExportUkgcFormatGetParametersQueryBrand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum PathsPublicGameConfigurationsSearchPostParametersQuerySort {
    SORT_INDEX_ASC = "SORT_INDEX_ASC",
    SORT_INDEX_DESC = "SORT_INDEX_DESC",
    CREATED_ASC = "CREATED_ASC",
    CREATED_DESC = "CREATED_DESC",
    KEEP_ORDER = "KEEP_ORDER",
    SORT_ALPHABETICAL = "SORT_ALPHABETICAL"
}
export enum GameSubtype {
    LIVE = "LIVE",
    COLLECTOR = "COLLECTOR"
}
export enum GameType {
    BINGO = "BINGO",
    CASINO = "CASINO",
    SLOTS = "SLOTS"
}
export enum JackpotType {
    SUPER_JACKPOT = "SUPER_JACKPOT",
    SMALL_JACKPOT = "SMALL_JACKPOT",
    MEGAPRIZE = "MEGAPRIZE"
}
export enum SafeGameCategory {
    ROULETTE = "ROULETTE",
    BACCARAT = "BACCARAT",
    PUNTOBANCO = "PUNTOBANCO",
    BLACKJACK = "BLACKJACK",
    POKER = "POKER",
    SPILLEAUTOMAT = "SPILLEAUTOMAT",
    BINGO = "BINGO",
    ANDET = "ANDET"
}
export enum SearchGameConfigurationsListRequestBrand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum SearchGameConfigurationsRequestBrand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum SearchGameConfigurationsRequestSort {
    SORT_INDEX_ASC = "SORT_INDEX_ASC",
    SORT_INDEX_DESC = "SORT_INDEX_DESC",
    CREATED_ASC = "CREATED_ASC",
    CREATED_DESC = "CREATED_DESC",
    KEEP_ORDER = "KEEP_ORDER",
    SORT_ALPHABETICAL = "SORT_ALPHABETICAL"
}
export enum SortGamesForBrandRequestBrand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum TileType {
    DEFAULT = "DEFAULT",
    VIDEO = "VIDEO",
    VIDEO_SMALL = "VIDEO_SMALL",
    HIDDEN = "HIDDEN"
}
export enum UkgcGameCategory {
    ROULETTE = "ROULETTE",
    BLACKJACK = "BLACKJACK",
    SLOTS = "SLOTS",
    OTHER = "OTHER",
    POKER_PEER_TO_PEER = "POKER_PEER_TO_PEER",
    BINGO = "BINGO"
}
export enum VendorProviderSearchGameConfigurationsRequestBrand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum Weekday {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY"
}
export enum ComponentsParametersBrandHeaderParameter {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum ComponentsParametersBrandQueryParameter {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
